import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const CarPartsIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_carpartsillustration_svg_a)"
      d="m85.58 126.676 43.645-7.896-42.363-12.79-31.728 5.622z"
    />
    <path
      fill="#28201E"
      d="M106.199 90.577c-4.203.462-8.134-.146-11.682-1.458a32.45 32.45 0 0 1-2.347-12.144c-.007-8.673 3.2-16.93 8.514-23.59 4.704-5.894 11.058-10.536 18.297-13.107 8.075 3.627 13.622 11.429 13.693 21.176.107 14.466-11.747 27.505-26.475 29.123m5.89-70.725c-25.672 2.821-46.333 25.547-46.149 50.76s21.145 43.365 46.816 40.545c25.672-2.822 46.334-25.547 46.15-50.76-.185-25.214-21.146-43.366-46.817-40.545M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#28201E"
      d="m104.492 115.162-16.831-8.439 12.226-5.293zm-94.025 40.433h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#28201E"
      d="m136.896 24.137 16.925 8.603-17.816 5.286zM10.466 155.595h214.488V19.563H10.467zm0-136.032h214.488v136.032H10.467z"
    />
    <path
      fill="#393939"
      d="M106.199 90.577c-4.203.462-8.134-.147-11.682-1.458a32.45 32.45 0 0 1-2.347-12.144c-.007-8.673 3.2-16.93 8.514-23.59 4.704-5.894 11.059-10.536 18.298-13.107 8.075 3.627 13.621 11.428 13.692 21.175.107 14.467-11.747 27.506-26.475 29.124m21.609-62.947c-25.689 2.655-46.497 25.246-46.478 50.46.021 25.214 20.863 43.502 46.551 40.847 25.69-2.653 46.499-25.245 46.479-50.459s-20.862-43.502-46.552-40.848M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M92.417 72.856c-.026.23-.056.46-.079.693.023-.232.053-.462.08-.693m-81.95 82.739h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M92.664 71.111q-.064.374-.12.752.055-.377.12-.752m-82.197 84.484h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M92.252 74.68c-.012.191-.03.382-.038.574.009-.192.026-.383.038-.574m-81.785 80.915h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M92.306 79.875c-.036-.404-.07-.81-.09-1.22.02.41.055.816.09 1.22m-81.84 75.72h214.488V19.563H10.467zm0-136.032h214.488v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M127.865 38.223C112.6 39.8 99.587 50.547 94.483 64.297a39.8 39.8 0 0 1 6.201-10.91c4.704-5.895 11.059-10.538 18.298-13.108 8.075 3.627 13.622 11.428 13.693 21.175.106 14.466-11.748 27.505-26.476 29.123-4.203.462-8.133-.146-11.682-1.458a32.4 32.4 0 0 1-2.183-8.888c1.697 17.655 16.983 30.035 35.587 28.114 19.73-2.038 35.711-19.388 35.695-38.752s-16.022-33.408-35.751-31.37M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M94.424 64.447c-.13.356-.25.717-.37 1.077.12-.36.238-.721.37-1.077m-83.957 91.148h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path fill="#4B4B4B" d="M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z" />
    <path fill="#4B4B4B" d="M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z" />
    <path fill="#4B4B4B" d="M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z" />
    <path
      fill="#C8C9C8"
      d="m124.598 40.278-2.021 26.066h12.065l-2.884-26.066zM10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#C8C9C8"
      d="m94.835 67.484 24.378 10.959 3.598-12.939-25.796-4.836zm-84.368 88.111h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#C8C9C8"
      d="m127.558 81.935 19.885 17.672 5.263-4.85-15.823-20.832zm-117.091 73.66h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#C8C9C8"
      d="m160.254 59.427-23.51 18.086-6.445-10.61 26.239-13.592zM10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#C8C9C8"
      d="m129.402 82.455-21.134 21.565-5.599-4.458L119.01 74.94zm-118.935 73.14h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#E4E4E4"
      d="M127.918 103.554c-17.033 1.76-30.853-10.365-30.867-27.084-.013-16.718 13.785-31.697 30.818-33.457s30.853 10.366 30.866 27.084c.014 16.719-13.784 31.698-30.817 33.457m-.052-65.331c-19.73 2.038-35.71 19.388-35.695 38.752.016 19.363 16.021 33.408 35.75 31.37s35.709-19.388 35.695-38.752c-.016-19.364-16.022-33.409-35.75-31.37m-117.4 117.372h214.488V19.563H10.467zm0-136.032h214.488v136.032H10.467z"
    />
    <path
      fill="#C8C9C8"
      d="M139.632 72.066c.005 6.389-5.268 12.113-11.777 12.787-6.51.672-11.791-3.962-11.796-10.35-.005-6.39 5.268-12.115 11.777-12.787s11.79 3.962 11.796 10.35M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M131.464 72.91c.002 1.962-1.617 3.719-3.616 3.925-1.999.207-3.62-1.215-3.621-3.176-.002-1.962 1.617-3.72 3.615-3.926s3.621 1.215 3.622 3.177M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M129.403 65.3c.001.585-.481 1.108-1.076 1.17-.595.06-1.079-.362-1.079-.947 0-.584.482-1.107 1.077-1.168.594-.062 1.078.361 1.078.946M10.467 155.596h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M123.503 80.676c0 .585-.482 1.108-1.076 1.169-.596.062-1.079-.36-1.08-.945 0-.584.482-1.108 1.077-1.17.595-.06 1.078.363 1.079.946M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M134.831 79.613c0 .584-.483 1.108-1.078 1.17-.595.06-1.078-.363-1.078-.947-.001-.585.482-1.107 1.077-1.168.594-.062 1.078.36 1.079.945M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M137.084 70.818c0 .584-.482 1.107-1.077 1.169-.595.06-1.078-.362-1.079-.946-.001-.585.482-1.108 1.077-1.169.594-.061 1.078.362 1.079.946M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M120.356 71.349c0 .584-.481 1.108-1.076 1.17-.595.06-1.079-.364-1.079-.948-.001-.584.481-1.106 1.076-1.167.595-.062 1.079.36 1.079.945m-109.89 84.246h214.488V19.563H10.467zm0-136.032h214.488v136.032H10.467z"
    />
    <path
      fill="url(#dhl__illustrations_carpartsillustration_svg_b)"
      d="m147.055 145.367 29.567-5.264-26.45-13.141-29.568 5.264z"
    />
    <path fill="#C39000" d="M176.622 106.644v33.459l-26.45-13.141V93.504z" />
    <path fill="#FBCE08" d="M176.622 106.644v33.459l46.47-8.323V98.322z" />
    <path fill="#393939" d="m148.311 95.79 27.8 13.811 48.844-8.747-27.802-13.812z" />
    <path fill="#706D6D" d="m148.311 93.35 27.8 13.812 48.844-8.748-27.802-13.811z" />
    <path
      fill="#000"
      d="M203.193 94.638c1.428-.624 3.834-.642 5.37-.041 1.537.602 1.625 1.596.198 2.22-1.429.625-3.834.644-5.371.042-1.536-.602-1.624-1.595-.197-2.22"
    />
    <path fill="#000" d="M202.184 88.055c-.003.018 0 7.674 0 7.674h7.593v-7.674" />
    <path
      fill="#393939"
      d="M203.193 86.965c1.428-.625 3.834-.644 5.37-.042s1.625 1.597.198 2.22c-1.429.625-3.834.643-5.371.042-1.536-.602-1.624-1.596-.197-2.22"
    />
    <path fill="#000" d="M186.752 116.943v8.007l1.901-.385v-8.019z" />
    <path
      fill="#000"
      d="m183.498 122.41 8.011-1.424.012-1.901-8.023 1.423zM208.997 117.851l8.012-1.424.012-1.901-8.024 1.424z"
    />
    <path fill="#706D6D" d="m166.079 90.232 31.575-5.404-8.139-4.04-31.574 5.404z" />
    <path fill="#28201E" d="M166.079 90.272v5.76l-8.139-4.08v-5.76z" />
    <path
      fill="#393939"
      d="M166.079 90.272v5.76l9.306-1.732v-5.76zM175.386 88.54v5.522l22.268-3.714v-5.52zM193.138 97.36v5.759l10.947-1.957v-5.759z"
    />
    <path fill="#28201E" d="M193.139 97.36v5.759l-17.754-8.82v-5.76z" />
    <path fill="#706D6D" d="m193.138 97.266 10.947-1.863-25.805-12.715-10.947 1.862z" />
    <path fill="#28201E" d="M148.311 93.35v2.48l27.8 13.772v-2.44l-27.567-13.854" />
    <path fill="#393939" d="M224.954 98.414v2.44l-3.729-1.773z" />
    <path
      fill="#860310"
      d="M173.602 100.046c1.429-.625 3.834-.644 5.37-.042 1.538.602 1.626 1.596.197 2.221-1.428.624-3.833.642-5.37.041s-1.625-1.595-.197-2.22"
    />
    <path fill="#860310" d="M172.593 93.461c-.003.019 0 7.675 0 7.675h7.593v-7.675" />
    <path
      fill="#D30511"
      d="M173.602 92.372c1.429-.626 3.834-.644 5.37-.043 1.538.602 1.626 1.597.197 2.221s-3.833.643-5.37.041c-1.536-.6-1.625-1.595-.197-2.22"
    />
    <path
      fill="url(#dhl__illustrations_carpartsillustration_svg_c)"
      d="m67.985 153.706 32.864-5.889-51.78-24.707-31.611 5.681z"
    />
    <path
      fill="#4B4B4B"
      d="M42.633 106.314c-1.339-.656-1.615-1.571-2.175-3.401-.682-2.253-1.619-5.338-5.46-7.218-3.838-1.885-6.852-.734-9.071.11-1.773.676-2.657 1.021-3.998.359l-7.074-4.21-3.238 4.85 6.66 4.219 1.02.5c3.842 1.881 6.852.737 9.054-.103 1.909-.728 2.73-.996 4.016-.365 1.29.631 1.58 1.446 2.176 3.408.686 2.25 1.626 5.333 5.46 7.21l4.93 2.519 2.505-5.483zm-32.166 49.281h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M16.117 94.119c0 1.531-1.263 2.904-2.823 3.065s-2.826-.95-2.827-2.481c-.002-1.532 1.262-2.904 2.822-3.065 1.56-.16 2.826.95 2.828 2.48m-5.65 61.476h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#C39000"
      d="m60.411 104.557 44.085 22.129-8.928 20.47-48.396-24.175zm-49.944 51.038h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#FBCE08"
      d="M111.532 135.979c.004 5.929-4.888 11.242-10.929 11.865-6.04.625-10.94-3.675-10.945-9.604s4.888-11.24 10.928-11.864 10.941 3.675 10.946 9.603M10.467 155.595h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#C39000"
      d="M64.878 112.732c.005 5.928-4.888 11.241-10.928 11.865s-10.94-3.677-10.946-9.605c-.004-5.929 4.889-11.24 10.93-11.864 6.039-.624 10.94 3.676 10.944 9.604m-54.411 42.863h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="m102.649 135.57 30.277 14.782-2.909 4.772-30.67-14.958zm-92.182 20.025h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#000"
      d="M134.51 152.621c.001 1.479-1.219 2.804-2.726 2.959s-2.728-.917-2.73-2.395c-.001-1.479 1.219-2.804 2.726-2.959s2.728.916 2.73 2.395m-124.043 2.974h214.487V19.563H10.467zm0-136.032h214.487v136.032H10.467z"
    />
    <path
      fill="#4B4B4B"
      d="M103.576 137.495c.002 1.478-1.219 2.803-2.725 2.959-1.507.155-2.73-.917-2.73-2.395-.002-1.48 1.219-2.804 2.725-2.96s2.729.916 2.73 2.396m-93.11 18.1h214.488V19.563H10.467zm0-136.032h214.488v136.032H10.467z"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_carpartsillustration_svg_a"
        x1={84.592}
        x2={88.833}
        y1={119.588}
        y2={107.073}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_carpartsillustration_svg_b"
        x1={134.045}
        x2={140.922}
        y1={136.463}
        y2={120.622}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.5} stopColor="gray" stopOpacity={0.5} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_carpartsillustration_svg_c"
        x1={50.614}
        x2={58.282}
        y1={143.223}
        y2={126.002}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
